import { StrategyDetails } from '@/components/strategyDetails-page';
import { Helmet as Head } from 'react-helmet';
import useRefresh from '../../hooks/use-refresh';

const StrategyDetailsPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Strategy Details</title>
      </Head>
      <StrategyDetails />
    </>
  );
};

export default StrategyDetailsPage;
